(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-tennis/assets/javascripts/match.js') >= 0) return;  svs.modules.push('/components/themes/sport-tennis/assets/javascripts/match.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_tennis = svs.themes.sport_tennis || {};
  svs.themes.sport_tennis.getLatestMatchesHomeAwayFilter = function() {
    return {
      all: { name: 'Alla', selected: true }
    };
  };

  svs.themes.sport_tennis.formatModelData = function(data) {
    var status = 0;
    if (((data || {}).events || {}).status) {
      status = data.events.status;
    }
    if (this.isLive(status)) return this.doFormatModelDataLive(data);
    return data;
  };

  svs.themes.sport_tennis.doFormatModelDataLive = function(data) {
    if (
      svs.utils.ns.isNamespace('svs.statistics.data.matchModels.events.events')
    ) {
      data = data || {};
      data.events = data.events || {};

      if (!data.events.odds) {
        data.events.odds = svs.statistics.data.matchModels.events.events.odds;
      }

      if (!data.events.favourite) {
        data.events.favourite =
          svs.statistics.data.matchModels.events.events.favourite;
      }
    }

    var response = data;
    response.events.chronologicalList = _.sortBy(
      response.events.chronologicalList,
      function(item) {
        return parseInt(item.time, 10);
      }
    );
    if (_.isObject(response.events)) {
      if (_.isObject(response.events.chronologicalList)) {
        _.each(response.events.chronologicalList, function(eventItem) {
          if (_.isObject(eventItem.extendedTime)) {
            eventItem.formatedTime = eventItem.extendedTime.time;
            eventItem.period = eventItem.extendedTime.period;
          } else if (_.isString(eventItem.time)) {
            if (eventItem.time === 'Okänd tid') {
              eventItem.time = 0;
            }
            eventItem.formatedTime = eventItem.time + "'";
          }
        });

        var groupedEvents = _.groupBy(
          response.events.chronologicalList,
          function(eventItem) {
            return eventItem.period;
          }
        );

        groupedEvents = _.sortBy(groupedEvents, function(item) {
          return parseInt(item, 10);
        }).reverse();

        for (var i in groupedEvents) {
          if (Object.prototype.hasOwnProperty.call(groupedEvents, i)) {
            groupedEvents[i] = this.reverseSortAttr(groupedEvents[i], 'time');
            var formatPeriodName = this.formatPeriodName(groupedEvents[i][0]);
            groupedEvents[i].periodName =
              formatPeriodName !== '' ? formatPeriodName : '';
          }
        }
        response.events.groupedEvents = groupedEvents;
      }
    }
    return response;
  };

  svs.themes.sport_tennis.groupEvents = function(statistics) {
    if (_.isObject(statistics) && _.has(statistics, 'matchEvents')) {
      statistics.matchEvents = _.sortBy(statistics.matchEvents, function(item) {
        return parseInt(item.time, 10);
      });

      statistics.matchEvents = this.reverseSortAttr(
        statistics.matchEvents,
        'time'
      );

      return statistics.matchEvents;
    }
    return null;
  };

  svs.themes.sport_tennis.formatPeriodName = function(groupedDataItem) {
    var res;
    if (groupedDataItem.period === 1) {
      res = 'Set 1';
    } else if (groupedDataItem.period === 2) {
      res = 'Set 2';
    } else if (groupedDataItem.period === 3) {
      res = 'Set 3';
    } else if (groupedDataItem.period === 4) {
      res = 'Set 4';
    } else if (groupedDataItem.period === 5) {
      res = 'Set 5';
    }
    return res;
  };

  svs.themes.sport_tennis.formatedMatchResult = function(
    match,
    homeOrAway,
    showHyphen
  ) {
    match = match || {};
    var homeResult = showHyphen ? '-' : '',
      awayResult = showHyphen ? '-' : '';

    if (match.result && match.result.length > 0) {
      var finalResult;
      if (match.result.find) {
        finalResult = match.result.find(function(result) {
          return result.isFinalResult;
        });
      } else {
        finalResult = _.findWhere(match.result, { isFinalResult: true });
      }
      if (finalResult) {
        homeResult = finalResult.home;
        awayResult = finalResult.away;
      } else {
        var result;
        if (match.result.find) {
          result = match.result.find(function(res) {
            return res.type === 18;
          }); 
        } else {
          result = _.findWhere(match.result, { type: 18 });
        }
        if (!result) {
          if (match.result.find) {
            result = match.result.find(function(res) {
              return res.type === 9;
            }); 
          } else {
            result = _.findWhere(match.result, { type: 9 });
          }
          if (!result) {
            if (match.result.find) {
              result = match.result.find(function(res) {
                return res.type === 2;
              }); 
            } else {
              result = _.findWhere(match.result, { type: 2 });
            }
          }
        }
        if (!result && typeof match.result === 'object') {
          result = match.result;
        }
        homeResult = result.home;
        awayResult = result.away;
      }
    } else {
      if (
        !!(match || {}).status &&
        (match || {}).homeTeam &&
        !!(match || {}).awayTeam
      ) {
        homeResult = match.homeTeam.result ? match.homeTeam.result : homeResult;
        awayResult = match.awayTeam.result ? match.awayTeam.result : awayResult;
      }
    }

    if (homeOrAway === 'home') {
      return homeResult;
    } else if (homeOrAway === 'away') {
      return awayResult;
    }
    if (homeResult === '' || awayResult === '') {
      return ' - ';
    }
    return homeResult + ' - ' + awayResult;
  };

  svs.themes.sport_tennis.hasResultOrLazy = function(match, isLazy) {
    if (isLazy) {
      return true;
    }
    match = match || {};
    if (match.result && match.result.length > 0) {
      var finalResult;
      if (match.result.find) {
        finalResult = match.result.find(function(result) {
          return result.isFinalResult;
        });
      } else {
        finalResult = _.findWhere(match.result, { isFinalResult: true });
      }
      if (finalResult) {
        return true;
      }
      var result;
      if (match.result.find) {
        result = match.result.find(function(res) {
          return res.type === 18;
        }); 
      } else {
        result = _.findWhere(match.result, { type: 18 });
      }
      if (!result) {
        if (match.result.find) {
          result = match.result.find(function(res) {
            return res.type === 9;
          }); 
        } else {
          result = _.findWhere(match.result, { type: 9 });
        }
        if (!result) {
          if (match.result.find) {
            result = match.result.find(function(res) {
              return res.type === 2;
            }); 
          } else {
            result = _.findWhere(match.result, { type: 2 });
          }
        }
      }
      if (!result) {
        return false;
      }
    }

    return false;
  };

  svs.themes.sport_tennis.reverseSortAttr = function(response, attr) {
    var items = response;
    items = _.sortBy(items, function(item) {
      return parseInt(item[attr], 10);
    }).reverse();

    return items;
  };

  svs.themes.sport_tennis.sortAttr = function(response, attr) {
    var items = response;
    items = _.sortBy(items, function(item) {
      return parseInt(item[attr], 10);
    });

    return items;
  };
})(svs);

 })(window);